import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ResetStreamKeyMutation } from "../graphql/mutations";
import type {
  ResetStreamKeyMutationType,
  ResetStreamKeyMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useResetStreamKeyMutation = (
  options?: MutationHookOptions<
    ResetStreamKeyMutationType,
    ResetStreamKeyMutationVariablesType
  >
) => {
  return useMutation<
    ResetStreamKeyMutationType,
    ResetStreamKeyMutationVariablesType
  >(ResetStreamKeyMutation, options);
};
